import * as React from "react";
import type {
  AppTabListOverflowMenuItemProps,
  AppTabListOverflowMenuItemState,
} from "./AppTabListOverflowMenu.types";
import {
  useMenuItem_unstable,
  useIsOverflowItemVisible,
} from "@fluentui/react-components";

export const useAppTabListOverflowMenuItem = (
  props: AppTabListOverflowMenuItemProps,
  ref: React.Ref<HTMLDivElement>
): AppTabListOverflowMenuItemState => {
  const { header } = props;

  const overflowMenuItemState = useMenuItem_unstable(
    {
      ...props,
    },
    ref
  ) as AppTabListOverflowMenuItemState;

  overflowMenuItemState.isVisible = useIsOverflowItemVisible(header.id);

  // Set the keytip execute function for the tabs
  const keytipOnExecute = React.useCallback(
    (_executeTarget: HTMLElement | null, _target: HTMLElement | null) => {
      header.onOverflowTabSelect?.(header.id);
    },
    [header]
  );

  overflowMenuItemState.keytipProps = header.keytipProps
    ? { ...header.keytipProps, onExecute: keytipOnExecute }
    : undefined;

  return {
    ...props,
    ...overflowMenuItemState,
  } as AppTabListOverflowMenuItemState;
};
